import axios from 'axios';
import { CORE_API } from '../env.config.js';

/**
 * Fetches the scan status of all file uploads associated with a specific record
 * @param {Object} coreToken - The core token object with token
 * @param {string} recordType - Type of the record (e.g., "WidgetSubmission")
 * @param {string} recordId - ID of the record
 * @returns {Promise} Axios response with file upload statuses
 */
const fetchFileUploadStatus = async (coreToken, recordType, recordId) => {
  const baseURL = CORE_API;

  try {
    const response = await axios.get(
      'file_uploads/status',
      {
        baseURL,
        params: {
          record_type: recordType,
          record_id: recordId,
        },
        headers: {
          Authorization: `Bearer ${coreToken.token}`,
          'X-Application-Source': 'widgets',
        },
      },
    );

    return response;
  } catch (error) {
    return error;
  }
};

export default fetchFileUploadStatus;
